<template>
	<div class="nav">
		<NuxtLink
			:to="langRoutes['nft-events'].children['index'][$i18n.locale].path"
			:class="classNames(langRoutes['nft-events'].children['index'][$i18n.locale].path)">
			{{ $t('events') }}
		</NuxtLink>
		<NuxtLink
			:to="langRoutes['nft-collections'].children['index'][$i18n.locale].path"
			:class="classNames(langRoutes['nft-collections'].children['index'][$i18n.locale].path)">
			{{ $t('nftCollections') }}
		</NuxtLink>
		<NuxtLink
			:to="langRoutes['nft-studios'].children['index'][$i18n.locale].path"
			:class="classNames(langRoutes['nft-studios'].children['index'][$i18n.locale].path)">
			{{ $t('studios') }}
		</NuxtLink>
	</div>
</template>

<script>
import langRoutes from "~/langRoutes";

export default {
    name: 'NavigationTabs',
    data() {
        return {
            langRoutes
        }
    },
	methods: {
		classNames(path) {
			return {
				'tab-btn nav-item btn-text': true,
				'active': this.$route.path.startsWith(path)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.header-nav-list {
    display: flex;
    gap: 3.2rem;
}
</style>
